const thankYou = {
    title: 'Merci',
    header: 'Merci!',
    message: "J'examine votre requête et je vous contacterai sous peu.",
    link: 'Accueil',
}

export default thankYou
